// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ../views/modules/events-block/assets/scss/events-block.scss
// module id = 61
// module chunks = 33